export default "__VITE_ASSET__Co8nA3TX__"